/* eslint-disable import/prefer-default-export */
export const RoomStateChanged = 'RoomStateChanged';

// 远程演示房间与 Player 通信的消息类型
export enum RemotePlayMessage {
    Null = 'Null',                                  // 占位
    // Room -> Player
    RoomStateChange = 'RoomStateChange',            // 房间状态改变消息

    // Player -> Room
    PlayerStateChange = 'PlayerStateChange',        // 幻灯片页码等信息改变消息
}

export interface IRoomState {
    roomAction: RoomAction;
    currentPage: number;
    currentFragment: number;
    currentRev: number;
}

export enum RoomAction {
    RemoteChangePage = 1,
    RemoteAllowFlipOn = 2,
    RemoteAllowFlipOff = 3,
    BeAudience = 4,
    LaserTrunOn = 5,
    LaserTrunOff = 6,
    PrevPage = 7,
    NextPage = 8,
    ExitShow = 9,
    TurnLaser = 10,
    SyncWithMaster = 11,
    PopWindowShow = 12,
    PopWindowHide = 13,
    ShowPlayerContent = 14,
    LiveBegin = 15,
    ZoomIn = 16,
    ZoomOut = 17,
    ToggleView = 18,
    RemoteLaserMove = 19,
    RemoteStopMainAnim = 20,
    MediaStateChanged = 21,
    TurnAnnotation = 22,
    AnnotationMessage = 23,
}

/**
 * ============================================================
 */
// Player中翻页等操作，引起Slide状态变化,房间层响应变化
export const PlayerStateChanged = 'PlayerStateChanged';

export interface IPlayerState {
    playerAction: PlayerAction;
    currentPage: number;
    currentFragment: number;
    pageCount: number;
    laserTurnOn: boolean;
    allowFilpPage: boolean;
    isManulFlipped: boolean;
    scale: number;
    x: number; // 鼠标移动坐标
    y: number; // 鼠标移动坐标
    playerInitData: Record<string, unknown>;
    lastError: string;
}

export enum PlayerAction {
    PlayerState            = 1,
    GotoPageFragment        = 2,
    PlayerReady             = 3,
    MobileOpenToolBar       = 4,
    EndPlay                 = 5,
    Loading                 = 6, // 播放器加载中状态
    Error                   = 7, // 错误状态
    LinkClicked             = 8, // 点击页面超链接
    DataLoading             = 9,
    CancelDataLoading       = 10, // 播放器加载中状态
    PlayerMouseMove         = 11,
    Media                   = 12,
    TurnLaser               = 14,
    TurnAnnotation          = 15,
    AnnotationMessage       = 16,
}

/**
 * 直播中的角色，演讲者、观众
 */
export enum LiveRoleType {
    None = 0, // 没有直播
    Master = 1, // 演讲者
    Audience = 2, // 观众
}
/**
 * 直播状态，直播中、暂停、结束
 */
export enum LiveState {
    None = 0, // 保留值
    OnAir = 1, // 正在直播
    Pause = 2, // 等待开始 & 暂停
    Ended = 3, // 直播结束
}
/**
 * 是否允许观众翻页：YES、NO
 */
export enum AllowFlipState {
    None = 0, // 保留
    YES = 2,
    NO = 1,
}

/**
 * Player 房间场景
 * 命名有 Meeting，当实际跟 Meeting 不强相关
 */
export enum MEETING_SCENE_SOURCE {
    /** 默认值 */
    None = 'None',
    /** 本地演示 */
    Local = 'Local',

    /** [远程演示] 观众/演示者 */
    MeetingRoom = 'MeetingRoom',
    /** [远程演示] 演示者(编辑态发起) */
    InEditor = 'InEditor',

    /** 单独的播放器，用于TOB需求 */
    TOBPlayer = 'tobplayer',

    /** 手机遥控器 */
    RemoteControl = 'remoteControl',
}

export enum ROLE {
    NONE = '0',            // 默认值
    MASTER = '1',          // 单独第三方演示-演示者
    AUDIENCE = '2',        // 远程演示-观众
}

export enum DOC_TYPE {
    UNKNOWN = -1,            // 默认值
    DOC = 0,
    SLIDE = 4,
    PDF = 6,
}

export enum MEETING_ROOM_STATE {
    PLAY = 1,
    AUDIENCE_WAIT = 2, // 演示者尚未开始，观众提前进入，或者演示者已经关闭浏览器，观众未退出。
    CLOSED = 3,
    INIT_LOADING = 10,
    AUDIENCE_LOADING = 20, // 原版本用于：观众本地已下载的PPT版本与演示不同，重新加载数据的等待状态
    ERROR_PAGE = 99,
    PLAYER_LOADING = 150, // 演示者或者观众进入，Player 加载中
    ROOM_FULL = 60010,
    ROOM_CLOSE = 70010, // 可能是房间关闭的error code
}

export enum MEETING_ROOM_ACTION {
    ROOM_READY = 1,
    PLAYER_LOADING,
    PLAYER_CANCEL_LOADING,
    MEETING_CLOSE,
    MEETING_ERROR,
    AUDIENCE_WAIT,
}

export enum LOGIN_ROLE {
    SPEAKER = 'speaker',
    AUDIENCE = 'audience',
}
